
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user-page",
      function () {
        return require("private-next-pages/user-page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user-page"])
      });
    }
  